// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Form Input Styles */
.fluid-input-base {
    padding: 0.5rem 0.625rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    transition: all 0.15s ease-in-out;
    background: white;
}

.fluid-input-focus {
    /* outline: none;
    border-color: transparent;
    box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.5); */
}

.fluid-input-text {
    width: 100%;
}

.fluid-textarea {
    resize: vertical;
    min-height: 80px;
}

/* Dropdown specific styles */
.fluid-dropdown-menu {
    border: 1px solid #e5e7eb !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
}

.fluid-dropdown-item {
    font-size: 0.875rem !important;
    padding: 0.5rem 0.75rem !important;
}

.fluid-dropdown-item-hover {
    background: #f3f4f6 !important;
}

.fluid-dropdown-item-active {
    background: #fef3e2 !important;
    color: #ea580c !important;
    font-weight: 500 !important;
}

.fluid-placeholder-text {
    color: #9ca3af;
}

.fluid-dropdown-arrow {
    opacity: 0.5;
    color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./src/fluidComponents/fluidForm/common-form-styles.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;IAC3C,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI;;oDAEgD;AACpD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,oCAAoC;IACpC,gCAAgC;IAChC,wDAAwD;AAC5D;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB","sourcesContent":["/* Common Form Input Styles */\n.fluid-input-base {\n    padding: 0.5rem 0.625rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    font-size: 0.875rem;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n    transition: all 0.15s ease-in-out;\n    background: white;\n}\n\n.fluid-input-focus {\n    /* outline: none;\n    border-color: transparent;\n    box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.5); */\n}\n\n.fluid-input-text {\n    width: 100%;\n}\n\n.fluid-textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n/* Dropdown specific styles */\n.fluid-dropdown-menu {\n    border: 1px solid #e5e7eb !important;\n    border-radius: 0.5rem !important;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;\n}\n\n.fluid-dropdown-item {\n    font-size: 0.875rem !important;\n    padding: 0.5rem 0.75rem !important;\n}\n\n.fluid-dropdown-item-hover {\n    background: #f3f4f6 !important;\n}\n\n.fluid-dropdown-item-active {\n    background: #fef3e2 !important;\n    color: #ea580c !important;\n    font-weight: 500 !important;\n}\n\n.fluid-placeholder-text {\n    color: #9ca3af;\n}\n\n.fluid-dropdown-arrow {\n    opacity: 0.5;\n    color: #6b7280;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
